module.exports = __webpack_public_path__ + "static/media/picture-(155).3e02e535.JPG";